<script setup>
defineProps({
  href:  { type: String, required: true },
  label: { type: String, default: 'Download PDF' },
  size:  { type: String, default: '' }
})
</script>

<template>
  <a :href="href" download class="download-btn">
    <span class="icon" aria-hidden="true">↓</span>
    {{ label }}<span v-if="size" class="size"> ({{ size }})</span>
  </a>
</template>

<style lang="scss" scoped>
.download-btn {
  display: inline-flex;
  align-items: center;
  gap: $space-2;
  padding: $space-2 $space-4;
  font-size: $font-size-sm;
  font-weight: 600;
  color: var(--color-primary);
  text-decoration: none;
  border: 1px solid var(--color-primary);
  border-radius: $radius;
  @include transition(background, color);

  .icon { font-size: $font-size-sm; }

  .size {
    font-weight: 400;
    color: var(--color-text-muted);
  }

  &:hover {
    background: var(--color-primary);
    color: var(--color-on-primary);
  }
}
</style>
